import { useProcessorDataContext } from '../../contexts/processor-data.context';
import { GatewayRenderer } from './gateway-renderer';

export type GatewaySwitchProps<StripeProps, JustifiProps> = React.PropsWithChildren<{
  stripeContent: React.FC<StripeProps>;
  justifiContent: React.FC<JustifiProps>;
  stripeProps: StripeProps;
  justifiProps: JustifiProps;
}>;

export function GatewaySwitch<StripeProps, JustifiProps>(props: GatewaySwitchProps<StripeProps, JustifiProps>) {
  const { activeGateway } = useProcessorDataContext();

  return <GatewayRenderer {...props} activeGateway={activeGateway} />;
}
